const content = `
# Comparison

Compare Mode runs two topologies with identical equipment and load profiles, then displays their results side-by-side to quantify efficiency differences.

## How Compare Mode Works

1. **Enable Compare Mode** — Click the "Compare Mode" button in the Topologies section header.
2. **Select Two Topologies** — Check exactly two topology rows. A summary bar shows your selections with color-coded chips.
3. **Click Compare** — The green "Compare These Topologies" button appears once two are selected.
4. **Configure Equipment** — The simulation config page shows both topologies and accepts a single shared equipment configuration.
5. **Run Comparison** — The API runs parallel simulations with identical inputs through both topologies.

## Interpreting Side-by-Side Results

The comparison dashboard shows both topologies in a split layout:

### Efficiency Badges

Two large efficiency circles at the top, one per topology, color-coded to match the topology's assigned color. The percentage difference is highlighted between them.

### Radar Chart

A **radar chart** overlays both topologies across multiple dimensions:

- PV to EV Efficiency
- PV to BESS Efficiency
- Grid to EV Efficiency
- System Efficiency
- Solar Utilization

The topology with the larger radar area has better overall performance. Look for individual axes where one topology dominates to understand which energy paths benefit most from the architecture change.

### Bar Charts

**Grouped bar charts** compare discrete metrics:

- Total Energy Delivered (kWh)
- Total Losses (kWh)
- Peak Grid Import (kW)
- Solar Energy Utilized (kWh)

### Energy Flow Charts

Side-by-side area charts show the time-series power flow for each topology. Look for differences in the loss area (red) and grid import area (blue) to see where the more efficient topology saves energy.

## Typical Comparison Scenarios

| Comparison | What It Shows |
|-----------|---------------|
| #1 Full AC vs #2 Full DC | Maximum theoretical efficiency gap (~9 percentage points) |
| #1 Full AC vs #3 Hybrid | Benefit of partial DC coupling for existing sites |
| #2 Full DC vs #10 High-Voltage DC | Marginal gain from 800 V to 1000 V DC bus |
| #4 DC Bus + AC Chargers vs #2 Full DC | Cost of keeping AC chargers on a DC-coupled system |

## Key Insight

The comparison view makes it concrete: for the same equipment on the same site, a DC-coupled topology typically delivers 5-10% more usable energy by eliminating unnecessary AC/DC conversion steps.
`;

export default content;
